"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerFileType = void 0;
var PartnerFileType;
(function (PartnerFileType) {
    PartnerFileType["CSV"] = "csv";
})(PartnerFileType = exports.PartnerFileType || (exports.PartnerFileType = {}));
